enum PromotionThresholdType {
  CartValue = 'cart-value',
  CartSize = 'cart-size',
}

export { PromotionThresholdType };
